import { ClockIcon, RunIcon, WarningIcon } from '@sharedCR/coreDesignSystem/icons';

import { StatusColor, StatusEnum } from 'constants/status';
import { COLOR_PALETTE } from 'constants/ui';

export const OverviewTileKey = {
  WORKING_NOW: 'workingNow',
  LAST_ACTIVITY: 'lastActivity',
  NEEDS_ATTENTION: 'needsAttention',
  AVG_TIME: 'avgTime',
};

export const OVERVIEW_TILE_CONFIG = [
  {
    key: OverviewTileKey.WORKING_NOW,
    title: 'Working now',
    Icon: RunIcon,
    getIconColor: ({ liveRunsCount }) =>
      liveRunsCount > 0 ? StatusColor[StatusEnum.INFO] : COLOR_PALETTE.GRAY[2],
  },
  {
    key: OverviewTileKey.LAST_ACTIVITY,
    title: 'Last activity',
    Icon: ClockIcon,
    getIconColor: () => StatusColor[StatusEnum.INFO],
  },
  {
    key: OverviewTileKey.NEEDS_ATTENTION,
    title: 'Needs your attention',
    Icon: WarningIcon,
    getIconColor: ({ needsAttentionCount }) =>
      needsAttentionCount > 0 ? StatusColor[StatusEnum.ERROR] : StatusColor[StatusEnum.SUCCESS],
  },
  {
    key: OverviewTileKey.AVG_TIME,
    title: 'Avg time per run',
    Icon: ClockIcon,
    getIconColor: () => StatusColor[StatusEnum.SUCCESS],
  },
];
